<template>
  <v-container fluid ma-0 pa-0 px-4 pb-4>
    <metrics-dashboard-header
      :last-reloaded="lastReloaded"
      :layout-mode="layoutMode"
      v-on:refresh-data="refreshData"
      v-on:toggle-layout-mode="toggleLayoutMode"
    ></metrics-dashboard-header>

    <v-layout row fluid wrap center class="pt-4" v-if="layoutMode">
      <v-flex class="text-xs-center">You can now change the layout by dragging & dropping the widgets into the correct order. Press the button again to save.</v-flex>
    </v-layout>
    <v-layout row fluid wrap class="pt-4">
      <draggable
        style="width: 100%; flex-wrap: wrap; display: flex;"
        :class="{ 'dashboard-section-placeholder': layoutMode, 'dashboard-no-section-list': layoutMode }"
        :list="widgetsWithoutSection"
        group="widgets"
        @change="widgetMoved"
        :ghost="true"
        :disabled="!layoutMode"
      >
        <v-flex
          class="pa-1"
          :class="widgetWidth(metricWidget)"
          v-for="(metricWidget, index) in widgetsWithoutSection"
          :key="metricWidget.id"
        >
          <component
            :index="index"
            :position="index"
            :is="getComponent(metricWidget.type)"
            :metricWidget="metricWidget"
            :layout-mode="layoutMode"
            v-on:fullscreen="goFullScreen"
          />
        </v-flex>
      </draggable>
    </v-layout>

    <metrics-dashboard-section
      v-for="(dashboardSection, index) in dashboardSections"
      :key="index"
      :dashboardSection="dashboardSection"
      :layoutMode="layoutMode"
      v-on:fullscreen="goFullScreen"
    >
    </metrics-dashboard-section>

    <full-screen-widget
      :metric-widget="fullScreenWidget"
      :widgetDialogFullscreen="widgetDialogFullscreen"
      fullscreen
      v-on:dismiss-fullscreen="dismissFullScreen"
    ></full-screen-widget>
  </v-container>
</template>
<script>
import "@/assets/styles/styles.css"
import { mapState } from "vuex"
import MetricsDashboardHeader from "@/components/metrics/MetricsDashboardHeader.vue"
import MetricsDashboardSection from "@/components/metrics/MetricsDashboardSection.vue"
import NumberWidget from "@/components/metrics/NumberWidget.vue"
import TrendlineWidget from "@/components/metrics/TrendlineWidget.vue"
import PiechartWidget from "@/components/metrics/PiechartWidget.vue"
import FullScreenWidget from "@/components/metrics/FullScreenWidget.vue"
import draggable from "vuedraggable"
import Vue from 'vue'

export default {
  name: "metrics-dashboard",
  components: {
    MetricsDashboardHeader,
    MetricsDashboardSection,
    NumberWidget,
    TrendlineWidget,
    PiechartWidget,
    FullScreenWidget,
    draggable
  },
  mounted() {
    Vue.store.dispatch('setPageTitle', "Metrics")
  },
  computed: {
    ...mapState({
      dashboardSections: (state) => state.widgets.dashboardSections,
      widgetsWithoutSection: (state) => state.widgets.widgetsWithoutSection
    })
  },
  methods: {
    getComponent(component) {
      switch (component) {
        case "number":
          return NumberWidget
        case "trend":
          return TrendlineWidget
        case "piechart":
          return PiechartWidget
      }
    },
    goFullScreen(widget) {
      this.fullScreenWidget = widget
      this.widgetDialogFullscreen = true
    },
    dismissFullScreen() {
      this.widgetDialogFullscreen = false
      this.fullScreenWidget = undefined
    },
    async refreshData() {
      await this.$store.dispatch("reloadWidgets")
      this.lastReloaded = new Date()
    },
    toggleLayoutMode() {
      this.layoutMode = !this.layoutMode
    },
    widgetWidth(metricWidget) {
      let widthCols = 4
      if (metricWidget && metricWidget.width) {
        widthCols = metricWidget.width * 4
      }
      return `xs${widthCols} sm${widthCols} md${widthCols} lg${widthCols} xl${widthCols}`
    },
    widgetMoved(added, removed, moved) {
      if (added && added.added && added.added.element && added.added.element.id) {
        added.added.element.dashboardSectionId = null
        this.$store.dispatch("updateWidget", added.added.element)
      }
      if (added || moved) {
        this.$store.dispatch('reorderWidgets')
      }
    }
  },
  data: () => ({
    lastReloaded: new Date(),
    widgetDialogFullscreen: false,
    fullScreenWidget: undefined,
    layoutMode: false
  })
}
</script>

<style>
.widgets {
  margin-top: 20px;
}

.widget {
  border-radius: 3px;
  box-sizing: border-box;
  width: 100%;
}

.widget--header {
  height: 44px;
}

.widget--content-1y {
  height: 140px;
}

.widget--content-2y {
  height: 280px;
}

.widget--content-3y {
  height: 420px;
}

.widget-style-blue {
  background: #132a39 !important;
  color: white !important;
}

.widget-style-blue .primary--text {
  color: white !important;
}

.widget-style-blue .theme--light.v-divider {
  border-color: rgba(255, 255, 255, 0.12);
}

.widget-style-blue .secondary--text {
  color: white !important;
}

.widget-style-outline {
  border: 2px solid #132a39 !important;
  background: none !important;
  box-shadow: none;
}

.arrow-link {
  padding-right: 35px;
  padding-bottom: 5px;
  background-image: url(../../assets/arrow-link-metrics-blue.svg);
  background-repeat: no-repeat;
  background-position: top 5px right;
  background-size: 23px;
}

.widget-style-blue .arrow-link {
  background-image: url(../../assets/arrow-link-metrics.svg);
}
.big-number {
  font-size: 5em;
  line-height: 1em;
  font-weight: 300;
}
.dashboard-no-section-list:empty:before {
  content: "Drag widget here to remove from section.";
}
.dashboard-no-section-list-placeholder {
  min-height: 192px;
}
</style>
